import { HTMLAttributes, ReactElement } from 'react';

interface Props extends HTMLAttributes<HTMLTimeElement> {
  className?: string;
  date?: string;
  format?: 'date' | 'time' | 'datetime';
}

export default function Version({
  className = '',
  date,
  format = 'datetime',
  ...props
}: Props): ReactElement {
  if (!date) return <></>;
  const _date = new Date(date);
  const isoString = _date.toISOString();

  // month ve day 0'dan basliyor.
  // const m = (_date.getMonth()+1).toString().padStart(2, '0');
  // const d = (_date.getDay()+1).toString().padStart(2, '0');
  // const dateString = `${_date.getFullYear()}/${m}/${d}`;
  // const timeString = `${_date.getHours()}:${_date.getMinutes()}`;
  // const dates = {
  //  date: dateString,
  //  time: timeString,
  //  datetime: dateString + ' ' + timeString,
  // };
  const dates = {
    date: _date.toLocaleDateString(),
    time: _date.toLocaleTimeString(),
    datetime: _date.toLocaleDateString() + ' ' + _date.toLocaleTimeString(),
  };
  return (
    <time dateTime={isoString} className={className} title={isoString} {...props}>
      {dates[format]}
    </time>
  );
}
